import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { FAQ_GROUPS } from "@/data/content";

export default function FAQ() {
  return (
    <div data-testid="faq-page">
      <Seo
        title="FAQ"
        path="/faq"
        description="Answers to common questions about laser hair removal, facials, skin treatments and what to expect at Barrhaven Beauty Lounge in Nepean, Ottawa."
      />
      <PageHero
        script="questions"
        title="Frequently Asked Questions"
        subtitle="Everything you need to know before your visit — from laser hair removal to skin treatments and what to expect."
      />

      <section className="mx-auto max-w-4xl px-5 md:px-10 py-16 md:py-24">
        {FAQ_GROUPS.map((group, gi) => (
          <Reveal key={group.category} delay={gi * 0.05}>
            <div className="mb-14">
              <h2 className="mb-4 font-serif-display text-3xl md:text-4xl tracking-tight">
                {group.category}
              </h2>
              <Accordion type="single" collapsible data-testid={`faq-group-${gi}`}>
                {group.items.map((f) => (
                  <AccordionItem key={f.id} value={f.id} className="border-b border-black/12">
                    <AccordionTrigger className="py-5 text-left font-serif-display text-xl md:text-2xl tracking-tight hover:no-underline">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 text-base leading-relaxed text-[#3d3d3d]">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
